import { render, staticRenderFns } from "./clients-list.vue?vue&type=template&id=028d6b1e"
import script from "./clients-list.vue?vue&type=script&lang=js"
export * from "./clients-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports